import { Item as CssModulesItem, Root as CssModulesRoot } from '@sunwebgroup/uds-ui/accordion'
import { styled } from 'styled-components'

export const Item = Object.assign(
  styled(CssModulesItem)``,
  { displayName: 'Accordion.Item' },
)

export const Root = Object.assign(
  styled(CssModulesRoot)``,
  { displayName: 'Accordion.Root' },
)
